import common from '../common'


// @param type 1 检测报告 2 施工报告
// * @param isConstructionBillPk 是否ConstructionBillPk true 或 false
// * @param pk 检测报告传 checkReportPk 幢[报 isConstructionBiLlPk = TRUE fConstructionBiLLPk FALSE 传receivebillPk

const startReport = (type, isConstructionBillPk, checkReportPk, callback) => {
    // 安卓
    if( !common?.isAndroid_ios() ) {
        if( window?.androidNative?.startReport ) { 
            window.androidNative.startReport(type, isConstructionBillPk, checkReportPk)
        }else {
            callback && callback()
        }
    }else {
        if( window?.webkit?.messageHandlers?.startReport) {
            window?.webkit.messageHandlers.startReport.postMessage({
                type:type || '', 
                isConstructionBillPk:isConstructionBillPk || '', 
                checkReportPk:checkReportPk || ''
            })
        }else {
            callback && callback()
        }
    }
}
export default startReport